export const environment = {
  production: false,
  apiBaseUrl: 'https://api.stage.bikaji.distiz.com/api',
  apiversion: 1.0,
  reportApiBaseUrl: 'https://distizreportapiqa.bikaji.com/api',
  adminApiBaseUrl: 'https://distizadminapiqa.bikaji.com',
  blobBaseUrl: 'https://bikajisap.blob.core.windows.net/sap-prd/'
};
